<template>
  <b-modal
    ref="mhlf_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px]"
    >
      <div>
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="icon-popup-warning"
          class="w-[100px] h-[100px] mx-auto mb-[20px]"
        >
        <h3 class="text-[24px] text-[#333333] font-semibold text-center">
          Atur Cut Off Time
        </h3>
      </div>
      <validation-observer
        ref="vo-modal-cot-form"
        #default
      >
        <b-form @submit.prevent="handleSubmit">
          <ReusableInput
            v-model="form.day"
            name="Hari"
            label="Hari"
            placeholder="Masukkan hari"
            rules="required"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus }">
              <b-form-select
                value-field="value"
                text-field="label"
                :value="value"
                :options="dayOptions"
                :disabled="disabled"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
          </ReusableInput>
          <ReusableInput
            v-model="form.inbound_hour"
            name="Cut Off Time Inbound"
            label="Cut Off Time Inbound"
            placeholder="Masukkan cut off time inbound"
            rules="required"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus, placeholder }">
              <b-form-timepicker
                locale="id-ID"
                :value="value"
                :disabled="disabled"
                :placeholder="placeholder"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
          </ReusableInput>
          <ReusableInput
            v-model="form.outbound_hour"
            name="Cut Off Time Outbound"
            label="Cut Off Time Outbound"
            placeholder="Masukkan cut off time outbound"
            rules="required"
          >
            <template #input="{ value, disabled, onInput, onBlur, onFocus, placeholder }">
              <b-form-timepicker
                locale="id-ID"
                :value="value"
                :disabled="disabled"
                :placeholder="placeholder"
                :time-format-options="{ hour: 'numeric', minute: 'numeric' }"
                @input="onInput"
                @blur="onBlur"
                @focus="onFocus"
              />
            </template>
          </ReusableInput>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <b-button
              type="button"
              variant="outline-primary"
              block
              @click="hide"
            >
              Batal
            </b-button>
            <b-button
              type="submit"
              :variant="isFieldComplete ? 'primary' : 'secondary'"
              block
              class="!flex items-center justify-center gap-[8px] mt-0"
              :disabled="!isFieldComplete || isPending"
            >
              <b-spinner
                v-if="isPending"
                small
              />
              Simpan
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { today } from '@/store/helpers'
import { toastError, toastSuccess } from '@/libs/toastification'
import ReusableInput from './Input.vue'
import { dayOptions } from '../config'

/**
 * ModalCutOffTimeForm
 * @description ModalCutOffTimeForm is a component that displays the modal cut off time form
 * @returns {Object} ModalCutOffTimeForm
 */
export default {
  name: 'ModalCutOffTimeForm',
  components: {
    ValidationObserver,
    ReusableInput,
  },
  data() {
    return {
      form: {
        day: 0,
        inbound_hour: '',
        outbound_hour: '',
      },
      today,
      index: null,
      mode: 'add',
      isPending: false,
      dayOptions,
    }
  },
  computed: {
    isFieldComplete() {
      return this.form.day && this.form.inbound_hour && this.form.outbound_hour
    },
  },
  methods: {
    /**
     * Show the modal cut off time form, this function would be called by the parent component to show the modal
     * @param {Object} params - The parameters
     * @param {String} params.mode - The mode
     * @param {Number} params.index - The index
     * @param {Object} params.initialData - The initial data
     */
    show({
      mode,
      index,
      initialData,
    }) {
      this.mode = mode
      if (mode === 'edit') {
        this.form = initialData
        this.index = index
      }
      this.$refs.mhlf_kompack.show()
    },
    /**
     * Hide the modal cut off time form, this function would be called by the parent component to hide the modal
     */
    hide() {
      this.$refs.mhlf_kompack.hide()
    },
    /**
     * Handle the submit
     */
    handleSubmit() {
      this.$refs['vo-modal-cot-form'].validate().then(valid => {
        if (valid) {
          const mappedForm = {
            day: this.form.day,
            inbound_hour: this.form.inbound_hour,
            outbound_hour: this.form.outbound_hour,
            type: 2, // 2 = cut off time
          }
          if (this.mode === 'edit') {
            mappedForm.id = this.form.id
            this.mutateUpdateCutOffTime(mappedForm)
          } else {
            this.mutateCutOffTime(mappedForm)
          }
        } else {
          toastError('Data cut off time tidak valid, silahkan cek kembali')
        }
      })
    },
    /**
     * Reset the form
     */
    resetForm() {
      this.form = {
        day: 0,
        inbound_hour: '',
        outbound_hour: '',
      }
      this.$refs['vo-modal-cot-form'].reset()
    },
    /**
     * Mutate the cut off time
     * @param {Object} form - The form
     */
    async mutateCutOffTime(form) {
      this.isPending = true
      try {
        await this.$http_new.post('/komship/api/v1/warehouse-operational-times', form)
        toastSuccess('Data cut off time berhasil disimpan')
        this.$emit('success')
        this.hide()
        this.resetForm()
      } catch (error) {
        toastError('Gagal mengubah data cut off time, silahkan refresh untuk coba lagi')
      } finally {
        this.isPending = false
      }
    },
    /**
     * Mutate the update cut off time
     * @param {Object} form - The form
     */
    async mutateUpdateCutOffTime(form) {
      this.isPending = true
      try {
        await this.$http_new.put(`/komship/api/v1/warehouse-operational-times/${form.id}`, form)
        toastSuccess('Data cut off time berhasil diubah')
        this.$emit('success')
        this.hide()
        this.resetForm()
      } catch (error) {
        toastError('Gagal mengubah data cut off time, silahkan refresh untuk coba lagi')
      } finally {
        this.isPending = false
      }
    },
  },
}
</script>
